<template>
  <div class="navbar">
    <div class="left-breadcrumb">
      <Breadcrumb />
    </div>
    <div class="right-menu">
      <Dropdown />
    </div>
  </div>
</template>

<script setup>
import Breadcrumb from './Breadcrumb.vue'
import Dropdown from './Dropdown.vue'
</script>

<style lang="scss" scoped>
.navbar {
  height: 48px;
  // overflow: hidden;
  position: relative;
  // background: #fff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  // background: red;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left-breadcrumb {
    border-radius: 8px;
    background: #ffffff;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 22px;
    flex-grow: 1;
    margin-right: 16px;
  }

  .right-menu {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: #ffffff;

    // &:focus {
    //   outline: none;
    // }

    // .right-menu-item {
    //   display: inline-block;
    //   padding: 0 8px;
    //   height: 100%;
    //   font-size: 18px;
    //   color: #5a5e66;
    //   vertical-align: text-bottom;

    //   &.hover-effect {
    //     cursor: pointer;
    //     transition: background 0.3s;

    //     &:hover {
    //       background: rgba(0, 0, 0, 0.025);
    //     }
    //   }

    //   &.theme-switch-wrapper {
    //     display: flex;
    //     align-items: center;

    //     svg {
    //       transition: transform 0.3s;

    //       &:hover {
    //         transform: scale(1.15);
    //       }
    //     }
    //   }
    // }

    // .avatar-container {
    //   margin-right: 0px;
    //   padding-right: 0px;

    //   .avatar-wrapper {
    //     margin-top: 10px;
    //     right: 8px;
    //     position: relative;

    //     .user-avatar {
    //       cursor: pointer;
    //       width: 30px;
    //       height: 30px;
    //       margin-right: 8px;
    //       border-radius: 50%;
    //     }

    //     .user-nickname {
    //       position: relative;
    //       left: 0px;
    //       bottom: 10px;
    //       font-size: 14px;
    //       font-weight: bold;
    //     }

    //     i {
    //       cursor: pointer;
    //       position: absolute;
    //       right: -20px;
    //       top: 25px;
    //       font-size: 12px;
    //     }
    //   }
    // }
  }
}
</style>
